import css from "./style.scss";
import cx from "classnames";
import { Text } from "preact-i18n";
import NetworkList from "../network-list";
import BackTo from "../back-to";
import useInvoice from "../../hooks/useInvoice";

const SelectNetwork = () => {
  const { invoice, clearCurrency } = useInvoice();

  return (
    <div class={cx(css.wrapper)}>
      <div class={cx(css.header, "text-center")}>
        <Text id="payment.select-network">Select network for USDT</Text>
      </div>
      <div class={cx(css.subheader, "text-center")}>
        <Text id="payment.ensure">
          Ensure the network you choose to deposit matches the withdrawal
          network, or assets may be lost.
        </Text>
      </div>
      <NetworkList list={invoice.currency?.types || []} />
      <div class={cx(css.back)}>
        <BackTo onClick={() => clearCurrency()}>
          <Text id="back.payment">Back to select payment method</Text>
        </BackTo>
      </div>
    </div>
  );
};

export default SelectNetwork;
